import actionTypes from 'SRC/modules/redux/actionTypes'

export const setIsServer = (isServer) => {
  return {
    type: actionTypes.SET_IS_SERVER_STATE,
    payload: isServer
  }
}
